import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ValidateDialogComponent } from 'src/app/dialogs/validate-dialog/validate-dialog.component';
import { CNDepartment } from 'src/app/models/cndepartment';
import { UserDepartmentService } from 'src/app/services/user/user-department.service';

@Component({
  selector: 'app-user-department-list',
  templateUrl: './user-department-list.component.html',
  styleUrls: ['./user-department-list.component.scss']
})
export class UserDepartmentListComponent implements OnInit {

  @Output() selected: EventEmitter<CNDepartment> = new EventEmitter();
  @Input() departments: CNDepartment[] = [];
  public selectedDepartment: CNDepartment;

  constructor(private dialog: MatDialog, private departmentSrv: UserDepartmentService) { }

  ngOnInit(): void {
    this.departmentSrv.departments().subscribe(departements => {
      this.departments = departements;
    });
  }

  public select(department: CNDepartment) {
    this.selectedDepartment = department;
    this.selected.emit(department);
  }

  public editDepartment(department: CNDepartment) {

  }

  public removeDepartment(department: CNDepartment) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Voulez-vous supprimer ce département ?',
      message: 'Attention, cette action est définitive',
      ok: {
        label: 'Supprimer',
        code: 'ok'
      },
      cancel: {
        label: 'Annuler',
        code: 'cancel'
      }
    };
    const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result === 'ok') {
        this.departmentSrv.removeDepartment(department);
      }
    });
  }
}
